/**
 * Clear Key System.
 *
 *
 * @beta
 */
export const CLEAR_KEY_SYSTEM = 'org.w3.clearkey'
